import script from "./ExposicaoOmashuExpressInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ExposicaoOmashuExpressInfo.vue?vue&type=script&setup=true&lang=js"

import "./ExposicaoOmashuExpressInfo.vue?vue&type=style&index=0&id=06f54d48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f54d48"]])

export default __exports__